import { showSnackbar, setLoading, toggleModal } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { call, put, takeLatest } from 'redux-saga/effects';
import API from 'services/api';
import {
  visitorTypeActions,
  visitorTypeNS,
  visitorTypeSelectors,
} from 'containers/Pages/Locations/VisitorTypes';
import { select } from '@redux-saga/core/effects';

export function* fetchVisitorTypesSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchVisitorTypes, {
      ...filters,
      from,
    });
    if (data.data) {
      const totalEntries = data.data.length;
      const id = yield select(visitorTypeSelectors.getSelectedRowID);
      yield put(
        visitorTypeActions.setGridList({ list: data.data, totalEntries }),
      );
      yield put(visitorTypeActions.setForceRefresh(false));
      if (id) {
        const rows = yield select(
          visitorTypeSelectors.getVisitorTypeListTransformed,
        );
        const value = rows.find(f => f.id === id);
        yield put(visitorTypeActions.setGridRowDetails({ details: value }));
      }
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchVisitorTypeDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    //select from the state
    const rows = yield select(
      visitorTypeSelectors.getVisitorTypeListTransformed,
    );
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(visitorTypeActions.setGridRowDetails({ details: value }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* createVisitorTypeSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { visitorType } = payload;
    const { status } = yield call(API.createVisitorTypes, visitorType);
    if (status === 200) {
      yield put(toggleModal(visitorTypeNS));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* updateVisitorTypeSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { visitorType } = payload;
    const { status } = yield call(API.updateVisitorTypes, visitorType);
    if (status === 200) {
      //const { id } = visitorType;
      yield put(toggleModal(visitorTypeNS));
      //yield call(fetchVisitorTypeDetailsSaga({ payload: { id } }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* visitorTypeSagas() {
  yield takeLatest(visitorTypeActions.fetchGridList, fetchVisitorTypesSaga);
  yield takeLatest(
    visitorTypeActions.fetchGridRowDetails,
    fetchVisitorTypeDetailsSaga,
  );
  yield takeLatest(visitorTypeActions.createRowEntry, createVisitorTypeSaga);
  yield takeLatest(visitorTypeActions.updateRowEntry, updateVisitorTypeSaga);
}
